import { createSlice } from '@reduxjs/toolkit'
import { ENROLL_QUEUE_KEY, initialState } from './model'

// เก็บคิวไว้ให้รอดการรีเฟรช/เปลี่ยนหน้า
const saveQueue = (state) => {
  try {
    window.localStorage.setItem(
      ENROLL_QUEUE_KEY,
      JSON.stringify({
        ticketId: state.ticketId,
        trainingPlanUuid: state.trainingPlanUuid,
        courseUuid: state.courseUuid,
        startedAt: state.startedAt,
        total: state.total,
        remaining: state.remaining,
      })
    )
  } catch (e) {
    // localStorage เต็ม/ถูกปิด ไม่ใช่เรื่องคอขาดบาดตาย ปล่อยผ่าน
  }
}

const clearQueue = () => {
  try {
    window.localStorage.removeItem(ENROLL_QUEUE_KEY)
  } catch (e) {
    // เหมือนกัน
  }
}

const queue = createSlice({
  name: 'queue',
  initialState,
  reducers: {
    /**
     * เข้าคิวรอบใหม่ - เฝ้าบัตรทุกใบ ไม่ว่าคิวจะสั้นหรือยาว
     * showNow = โชว์ popup เลย (คิวยาวเกินเกณฑ์) ถ้าไม่ใช่ก็เฝ้าเงียบ ๆ ไว้
     * แล้วค่อยโชว์ถ้ารอนานเกินไป (กันเคสหมุนค้างเพราะผลไม่กลับมา)
     */
    startQueueWaiting: (state, { payload }) => {
      state.ticketId = payload?.ticketId || null
      state.total = Number(payload?.total) || 0
      state.remaining = state.total
      state.trainingPlanUuid = payload?.trainingPlanUuid || null
      state.courseUuid = payload?.courseUuid || null
      state.startedAt = Date.now()
      state.isWaiting = !!payload?.showNow
      state.isResumed = false
      saveQueue(state)
    },
    // รอนานเกินไปแล้ว เปิดให้เห็นว่ากำลังรออะไรอยู่
    showQueuePopup: (state) => {
      state.isWaiting = true
    },
    // กลับเข้ามาดูทีหลัง ค่าเดิมมาจาก localStorage
    resumeQueueWaiting: (state, { payload }) => {
      state.ticketId = payload?.ticketId || null
      state.total = Number(payload?.total) || 0
      state.remaining = Number(payload?.remaining) || 0
      state.trainingPlanUuid = payload?.trainingPlanUuid || null
      state.courseUuid = payload?.courseUuid || null
      state.startedAt = Number(payload?.startedAt) || Date.now()
      state.isWaiting = true
      state.isResumed = true
    },
    // แก้เลขคิวจากค่าจริงฝั่งหลังบ้าน (ตอน resume / ระหว่าง poll)
    setQueueRemaining: (state, { payload }) => {
      const next = Number(payload)
      if (!Number.isFinite(next)) return
      // คิวเดินหน้าอย่างเดียว ห้ามเด้งกลับขึ้น
      state.remaining = Math.max(0, Math.min(state.remaining, next))
      saveQueue(state)
    },
    /**
     * worker เคลียร์ไป 1 ใบ - ถ้ามีเลขบัตรที่เพิ่งเสร็จติดมาด้วย ใช้คำนวณลำดับตรง ๆ
     * (คิวเป็น FIFO สายเดียว บัตรที่เลขน้อยกว่าถูกทำไปแล้วทั้งหมด)
     * ไม่มีเลขบัตรมาก็ลดทีละ 1 แบบเดิม - ทั้งสองทางลดลงอย่างเดียว ไม่เด้งขึ้น
     */
    tickQueue: (state, { payload }) => {
      const served = Number(payload?.servedTicketId)
      const mine = Number(state.ticketId)

      if (Number.isFinite(served) && Number.isFinite(mine)) {
        const next = Math.max(0, mine - served)
        if (next < state.remaining) {
          state.remaining = next
          saveQueue(state)
        }
        return
      }

      if (state.remaining > 0) {
        state.remaining -= 1
        saveQueue(state)
      }
    },
    // กด "ใช้งานต่อ" - แค่ปิดกล่อง คิวยังอยู่ กลับเข้าหน้าคลาสเดิมแล้วเด้งใหม่ได้
    dismissQueue: (state) => {
      state.isWaiting = false
    },
    // ถึงคิวแล้ว (หรือ error) - จบเลย ล้างของที่เก็บไว้
    stopQueueWaiting: (state) => {
      state.ticketId = null
      state.total = 0
      state.remaining = 0
      state.trainingPlanUuid = null
      state.courseUuid = null
      state.startedAt = null
      state.isWaiting = false
      state.isResumed = false
      clearQueue()
    },
  },
})

export const {
  startQueueWaiting,
  showQueuePopup,
  resumeQueueWaiting,
  setQueueRemaining,
  tickQueue,
  dismissQueue,
  stopQueueWaiting,
} = queue.actions

export default queue.reducer
